import React from 'react';

/**
 * Preferred address display template
 */
export const PreferredTemplate: React.FC<{ isPreferred?: boolean }> = ({ isPreferred }) => (
  <span>{isPreferred ? 'Yes' : 'No'}</span>
);

export default PreferredTemplate;
